<template>
	<ConversionForm :formData="formData">
		
		<el-col :span="24" v-if="formData.deep">
			<el-row class="row-box">
				<p class="border-title">三阶出价</p>
				<el-col :span="7" class="col-h" >
					<el-form-item label="深度转化目标"  required>
						<el-select 
							v-model="formData.deepTarget" 
							@change="()=>handleChangeDeepName('deepType')"
						>
							<el-option 
								v-for="item in main.deepConversionNames" 
								:label="item.label" :key="item.value" 
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7" class="col-h">
					<el-form-item label="深度转化出价"  :rules="moneyRules" prop="deepCost">
						<el-input 
							v-model="formData.deepCost" 
							placeholder="请输入价格" @input="(value)=>handleInput('deepCost', value)" 
						/>
					</el-form-item>
					<div class="form-item__tip" v-if="priceAvg">
						<TipInfo :data="priceAvg"/>
					</div>
				</el-col>
			</el-row>
		</el-col>
		
	</ConversionForm>
</template>

<script>
import ConversionForm from './conversionForm.vue'
import _ from 'lodash';
import TipInfo from './tipInfo'
export default {
    inject: [ 'global' , 'moneyRules', 'main'],
	props: ["formData"],
	components: { ConversionForm , TipInfo},
	computed: {
		
	},
    data() {
        return {
            rules: {},
			priceAvg: '', // 出价均值
        }
    },
	methods: {
		
		handleChangeDeepName (key) {
			this.$set(this.formData, key, '');
			this.avgValue(this.formData.deepCost);
		},
		handleInput(key, value) {
			const num = this.global.handleValidNumber(value);
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			if(!value) {
				return
			}
			const params = {
				price_type: this.formData.way,
				tracking_id: this.formData.target,
				deep_conv_type: this.formData.deepTarget 
			};
			if(!this.formData.deepName) {
				return
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.ocpx_deep_price_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.ocpx_deep_price_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
	},
	watch: {
		
	}
}
</script>

<style lang="scss" scoped>
.row-box {
	border: 1px solid #dcdfe6;
	margin: 0 12px 20px;
	border-radius: 8px;
	padding-top: 20px;
	position: relative;
}
.border-title {
	position: absolute;
	top: -8px;
	left: 20px;
	color: #606266;
	background: #fff;
}
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>